
import Vue from 'vue';

export default Vue.extend({
	name: 'OpenSourceApiCard',
	props: {
		appName: {
			type: String,
			required: true,
		},
		// Short text badge shown in the logo tile (no icon asset needed).
		badge: {
			type: String,
			required: true,
		},
		// API-shape label with a lead dot (e.g. 'REST API', 'Node-graph API').
		apiStyleLabel: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			required: true,
		},
		// Primary CTA target: RunDiffusion's open-source API guide.
		guideUrl: {
			type: String,
			required: true,
		},
		guideLabel: {
			type: String,
			default: 'Read the guide',
		},
	},
	methods: {
		openGuide () {
			if (this.guideUrl) {
				window.open(this.guideUrl, '_blank', 'noopener,noreferrer');
			}
		},
	},
});
